export default "__VITE_ASSET__CIJwuiOS__"